import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { tesaDarkGrey, tesaWhite } from "../../styles/colors";

export enum SampleType {
  Substrate = 1,
  Product,
}
interface SampleChipDetails {
  testRequestId: string;
  sampleType: SampleType;
}

const useStyles = makeStyles<Theme, PredefinedSampleChipProps & { spacing?: number }>((theme) =>
  createStyles({
    chipRoot: {
      marginBottom: "2px",
    },
    chipText: {
      backgroundColor: tesaDarkGrey,
      borderRadius: "18px",
      color: tesaWhite,
      display: "inline-block",
      fontFamily: "Proxima Nova",
      fontSize: "0.75rem",
      fontWeight: 400,
      letterSpacing: "0.4px",
      lineHeight: "0.75rem",
      padding: "6px 8px",
      verticalAlign: "middle",
    },
    containerRoot: ({ spacing }) => ({
      display: "flex",
      alignItems: "center",

      "& > * + *": {
        marginLeft: theme.spacing(spacing || 1),
      },
    }),
    ellipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  }),
);
interface PredefinedSampleChipProps {
  className?: string;
  details?: SampleChipDetails;
}

const PredefinedSampleChip = (props: PredefinedSampleChipProps) => {
  const classes = useStyles(props);
  const { className, details } = props;
  const { testRequestId, sampleType } = details || {};
  const testReqIdTemplate = `in ${testRequestId}`;
  const textContent = `Predefined ${details ? testReqIdTemplate : ""}`;
  const content = (
    <div className={[classes.chipRoot, className].join(" ")}>
      <span className={classes.chipText}>{textContent}</span>
    </div>
  );
  const href = `requests/${testRequestId}/${sampleType}`;

  return details ? (
    <a href={href} rel="noopener noreferrer" target="_blank">
      {content}
    </a>
  ) : (
    content
  );
};

export const WithPredefinedChip: React.FC<PredefinedSampleChipProps & { spacing?: number; text: string }> = ({
  text,
  ...props
}) => {
  const classes = useStyles(props);
  return (
    <div className={classes.containerRoot}>
      <span className={classes.ellipsis}>{text}</span>
      <PredefinedSampleChip {...props} />
    </div>
  );
};

export default PredefinedSampleChip;
